(function ($) {
	$(document).ready(function () {
		$(document).on('click', '.b-modal-btn', function (e) {
			e.preventDefault();

			var target = $(this).data('target');
			if (!target) {
				return;
			}

			$(target).addClass('b-is-active');
		});

		$(document).on('click', '.b-modal-close, .b-modal-background', function (e) {
			e.preventDefault();

			$(this).closest('.b-modal').removeClass('b-is-active lb-stat-open').removeAttr('style');
		});

		$(document).on('click', '.b-modal.b-is-active', function (e) {
			if (e.target === this) {
				$(this).removeClass('b-is-active lb-stat-open').removeAttr('style');
			}
		});

		/*---------------------------------------------
			sync user=name edição de perfil
		---------------------------------------------*/
		$('#field_1').keyup(function () {
			$('#field_3').val(labead_removeEspeciais($('#field_1').val()));
		});

		/*---------------------------------------------
			force mask usuario
		---------------------------------------------*/
		$('#field_3').keyup(function () {
			$('#field_3').val(labead_removeEspeciais($('#field_3').val()));
		})

		/*---------------------------------------------
			caracteres especias limite usuario to 25
		---------------------------------------------*/
		function labead_removeEspeciais(params) {
			if (params.length > 25) { params = params.slice(0, 25); }
			var result = params.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\-]+/g, '-');
			return result;
		}


	})//ready



})(jQuery);





























